// import React from "react";
// import { motion } from "framer-motion";
// import "./Collabration.css";

// function Collaboration() {
//     return (
//         <div className="design-container">
//             {/* Software facilities - LEFT side animation */}
//             <motion.div
//                 className="design-section"
//                 initial={{ x: -100, opacity: 0 }}
//                 animate={{ x: 0, opacity: 1 }}
//                 transition={{ duration: 0.8 }}
//                 whileHover={{
//                     scale: 1.05,
//                     y: -10,
//                     boxShadow: "0px 15px 30px rgba(0,0,0,0.4)",
//                 }}
//             >
//                 <h2>SCL R&D Collabration</h2>
//                 <ul>
//                     <li>Massachusetts Institute of Technology, USA</li>
//                     <li>NADCA, USA</li>
//                     <li>Ryerson University, Canada</li>
//                     <li>Fraunhofer Institutes, Germany</li>
//                     <li>Aachen University, Germany</li>
//                     <li>CSIRO, Australia</li>
//                     <li>Warwick University, UK</li>
//                     <li>Indian Institute of Technology, Madras</li>
//                     <li>Indian Institute of Science, Bangalore</li>
//                 </ul>
//             </motion.div>

//         </div>
//     );
// }

// export default Collaboration;


import React from "react";
import { motion } from "framer-motion";
import "./Collabration.css";

function Collaboration() {
    return (
        <div className="design-container">
            {/* Software facilities - LEFT side animation */}
            <motion.div
                className="design-section"
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.8 }}
                whileHover={{
                    scale: 1.05,
                    y: -10,
                    boxShadow: "0px 15px 30px rgba(0,0,0,0.4)",
                }}
            >
                <h2>SCL R&D Collaboration</h2>
                <ul>
                    <li>Massachusetts Institute of Technology, USA</li>
                    <li>NADCA, USA</li>
                    <li>Ryerson University, Canada</li>
                    <li>Fraunhofer Institutes, Germany</li>
                    <li>Aachen University, Germany</li>
                    <li>CSIRO, Australia</li>
                    <li>Warwick University, UK</li>
                    <li>Indian Institute of Technology, Madras</li>
                    <li>Indian Institute of Science, Bangalore</li>
                </ul>
            </motion.div>
        </div>
    );
}

export default Collaboration;
